<template>
  <div class="notification-area">
    <label v-if="notice.message" v-html="notice.message"></label>
    <label v-else>お知らせはありません</label>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { dataFetchNotice } from '@/composable/data_fetch_common';

// お知らせ文言
const notice = ref([]);

// お知らせ文言取得
const getNotice = async () => {
  notice.value = await dataFetchNotice();
};

// 初期データ取得
onMounted(() => {
  getNotice();
});
</script>

<style scoped>
.notification-area {
  font-size: 1.3rem;
  font-weight: 400;
  color: #3e4a41;
  padding: 18.82px;
}
</style>
